import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'eos-logout',
  templateUrl: "./logout.component.html",
  styles: []
})
export class LogoutComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.cleanup();
  }

  private cleanup() {
    this.authService.clearUserInfo();
    localStorage.removeItem('client_config');
  }

}
